import React, { memo, forwardRef } from "react";
const SvgLagrange2Ndderivative = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.95 7.869c.113-.367.271-.603.474-.71.203-.106.393-.159.57-.159a.99.99 0 01.702.266.805.805 0 01.304.656c0 .06-.006.13-.019.213-.013.082-.044.189-.095.319l-.911 2.713c-.114.354-.266.585-.456.691-.19.095-.373.142-.55.142-.254 0-.482-.077-.684-.23-.19-.154-.285-.367-.285-.639v-.195c.013-.083.044-.195.095-.337l.854-2.73zM22.95 7.869c.113-.367.271-.603.474-.71.203-.106.393-.159.57-.159a.99.99 0 01.702.266.805.805 0 01.304.656c0 .06-.006.13-.019.213-.013.082-.044.189-.095.319l-.911 2.713c-.114.354-.266.585-.456.691-.19.095-.373.142-.55.142-.254 0-.482-.077-.684-.23-.19-.154-.285-.367-.285-.639v-.195c.013-.083.044-.195.095-.337l.854-2.73z"
      />
      <rect width={10} height={14} x={7} y={12} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgLagrange2Ndderivative.displayName = "SvgLagrange2Ndderivative";
const MemoForwardRef = memo(SvgLagrange2Ndderivative);
export default MemoForwardRef;
